import { formatDate } from "@/lib/utils"
import { urlForImage } from "@/sanity/lib/image"
import Image from "next/image"
import Link from "next/link"

interface ArticleCardProps {
	headline: string
	tag: string
	date: string
	url: string
	image?: any
	video?: any
	excerpt?: string
}

export default function ArticleCard({headline, tag, date, url, image, video, excerpt}:ArticleCardProps) {
	return (
		<Link href={url} className="text-lg leading-110 group">
			{image && (
				<Image
					className="w-full rounded-[8px] object-cover aspect-video opacity-100 group-hover:opacity-80 transition-opacity"
					src={urlForImage(image).width(1080).url()}
					sizes={`(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw`}
					width={image?.asset?.metadata?.dimensions?.width}
					height={image?.asset?.metadata?.dimensions?.height}
					alt={headline}
					placeholder="blur"
					blurDataURL={image?.asset?.metadata?.lqip}
					quality={90}
				/>
			)}
			<div className="mt-4 font-400 text-xl">{headline}</div>
			{excerpt && <div className="mt-4 font-400 text-lg text-grey dark:text-grey-dark">
				{excerpt}
			</div>}
			<div className="mt-3 text-sm leading-105 text-grey dark:text-grey-dark group-hover:text-black dark:group-hover:text-white">{formatDate(new Date(date))} — {tag}</div>
		</Link>
	)
}

